import * as Sentry from '@sentry/browser';
import { commonSentryConfig } from './common-sentry-config';
import { persistJourneyBreadcrumb } from './journey-breadcrumbs';

Sentry.init({
  ...commonSentryConfig,
  tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE),
  tracePropagationTargets: ['www.stdcheck.local', 'stdcheck.com'],
  integrations: [Sentry.browserTracingIntegration()],
  // Persist each breadcrumb so the pre-checkout journey survives the full page
  // load into the ng-checkout SPA and can be replayed onto checkout errors.
  beforeBreadcrumb(breadcrumb) {
    persistJourneyBreadcrumb(breadcrumb);

    return breadcrumb;
  },
  ignoreErrors: [
    'BraintreeError: Cannot contact the gateway at this time.',
    'TypeError: Load failed (www.chatbase.co)',
  ],
  denyUrls: [
    'api.livechatinc.com',
    'bat.bing.com',
    'cdn.livechatinc.com',
    'cdn.ywxi.net',
    'connect.facebook.net',
    'my.hellobar.com',
    'www.mczbf.com',
    'www.shopperapproved.com',
    'www.trustedsite.com',
    'www.upsellit.com',
  ],
});
